import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaUsers,
  FaCartPlus,
  FaListAlt,
  FaTasks,
  FaTrashAlt,
  FaCalendarPlus,
  FaCalendarTimes,
  FaUserPlus,
} from "react-icons/fa";
import "./dashboard1.css";
import Layout from "../components/layout";
import { useSelector } from "react-redux";

const Dashboard = () => {
  const navigate = useNavigate();
  const { userRole } = useSelector((state) => state.role);

  // Dynamische Gruppen
  const dynamicGroups = ["Administration", "Produkt", "Event"];

  // Dashboard-Karten
  const cards = {
    admin: [
      { title: "SSO senden", icon: <FaUserPlus />, link: "/admin/ssoinv" },
      {
        title: "Benutzerverwaltung",
        icon: <FaUsers />,
        link: "/admin/user-management",
      },
      {
        title: "Produkt hinzufügen",
        icon: <FaCartPlus />,
        link: "/admin/add-product",
        group: "Produkt",
      },
      {
        title: "Archiv anzeigen",
        icon: <FaListAlt />,
        link: "/admin/kart-archive",
        group: "Produkt",
      },
      {
        title: "Kategorie Ordnen",
        icon: <FaTasks />,
        link: "/admin/category-order",
        group: "Produkt",
      },
      {
        title: "Produkt löschen",
        icon: <FaTrashAlt />,
        link: "/admin/delete-product",
        group: "Produkt",
      },
      {
        title: "Event hochladen",
        icon: <FaCalendarPlus />,
        link: "/admin/event-upload",
        group: "Event",
      },
      {
        title: "Event löschen",
        icon: <FaCalendarTimes />,
        link: "/admin/event-delete",
        group: "Event",
      },
    ],
    worker: [], // Leeres Array für worker-Rolle, falls benötigt
    all: [],    // Leeres Array als Fallback für andere Rollen
  };

  // Karten für die aktuelle Rolle auswählen
  const getRoleCards = () => {
    if (userRole === "admin") return cards.admin;
    if (userRole === "worker") return cards.worker;
    return cards.all; // Fallback für andere Rollen
  };

  // Karten nach Gruppen organisieren
  const groupCardsByCategory = () => {
    const groupedCards = dynamicGroups.reduce(
      (acc, group) => {
        acc[group] = [];
        return acc;
      },
      { none: [], Common: [] }
    );

    const roleCards = getRoleCards();

    roleCards.forEach((card) => {
      if (card.group && groupedCards[card.group]) {
        groupedCards[card.group].push(card);
      } else {
        groupedCards.none.push(card);
      }
    });

    return groupedCards;
  };

  const groupedCards = groupCardsByCategory();

  const formatTitle = (title) => {
    const regex = new RegExp(`\\s*\\((${dynamicGroups.join("|")})\\)`, "i");
    return title.replace(regex, "");
  };

  const handleCardClick = (link) => navigate(link);

  return (
    <Layout>
      <div className="dashboard-container">
        <div className="dashboard-content">
          {Object.entries(groupedCards).map(
            ([group, cards]) =>
              cards.length > 0 && (
                <div key={group} className="dashboard-group">
                  <h2 className="dashboard-group-title">
                    {group === "none" ? "Allgemein" : group}
                  </h2>
                  <div className="dashboard-grid">
                    {cards.map((card, index) => (
                      <div
                        key={index}
                        className="dashboard-card"
                        onClick={() => handleCardClick(card.link)}
                      >
                        <div className="card-icon">{card.icon}</div>
                        <h3 className="card-title">
                          {formatTitle(card.title)}
                        </h3>
                      </div>
                    ))}
                  </div>
                </div>
              )
          )}
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;